var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1220)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4989 0.5C15.2194 0.588499 13.7239 1.40749 12.8525 2.47399C12.0575 3.44148 11.4035 4.87847 11.6585 6.27497C13.0565 6.31847 14.5009 5.47997 15.3379 4.39548C16.1209 3.38598 16.7134 1.95799 16.4989 0.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5554 8.55204C20.3269 7.01155 18.6004 6.11755 16.9699 6.11755C14.8174 6.11755 13.9069 7.14805 12.4114 7.14805C10.8694 7.14805 9.69792 6.12055 7.83643 6.12055C6.00794 6.12055 4.06095 7.23805 2.82646 9.14904C1.09097 11.84 1.38797 16.8995 4.20045 21.209C5.20695 22.751 6.55094 24.4849 8.30893 24.4999C9.87342 24.5149 10.3144 23.4965 12.4339 23.486C14.5534 23.474 14.9554 24.5134 16.5169 24.4969C18.2764 24.4834 19.6939 22.562 20.7004 21.02C21.4219 19.9145 21.6904 19.358 22.2498 18.11C18.1804 16.5605 17.5279 10.7735 21.5554 8.55204Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1220"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.2ddfb023174fc68443208a49fb432bfa.svg";
export { ForwardRef as ReactComponent };